<template>
    <div :class="customClass" class="selectPicker">
        <van-field
            :value="this[this.paramName]"
            :name="paramName === 'selectPicker' ? '' : paramName"
            :label="label"
            :left-icon="leftIcon"
            :right-icon="rightIcon"
            :rules="rules"
            readonly
            :disabled="disabled"
            :required="required"
            clickable
            :placeholder="placeholder"
            @click="onClick"
        />
        <van-field
            class="mod-selectCode"
            v-if="paramCode"
            :value="this[this.paramCode]"
            readonly
            clickable
            :name="paramCode"
        />
        <van-popup v-model="showSelect" position="bottom">
            <van-picker
                :title="title"
                v-model="currentSelect"
                show-toolbar
                value-key="label"
                :columns="options"
                :default-index="dIndex"	
                @cancel="showSelect = false"
                @confirm="onConfirm"
                @change="onChange"
            ></van-picker>
        </van-popup>
    </div>
</template>
<script>
/**
 * options数据格式
 * {
 *   label:'',
 *   value:'', 
 *   ['other']:''
 * }
 * @ {string} paramName 选中元素的label 如果有传此参数 表单提交时会带上选中的label
 * @ {string} paramCode 选中元素的value 如果有传此参数 表单提交时会带上选中的value 
 *
 */
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        rules: {
            type: Array,
            default: () => {
                return []
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        initValue: {
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        leftIcon: {
            type: String,
            default: ''
        },
        rightIcon: {
            type: String,
            default: 'arrow'
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        paramName: {
            type: String,
            default: 'selectPicker'
        },
        paramCode: {
            type: String,
            default: ''
        },
        defaultIndex: {
            type: Number,
            default: -1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            [this.paramName]: this.initValue,
            [this.paramCode]: this.initValue,
            currentSelect: '',
            showSelect: false,
            dIndex:this.defaultIndex
        }
    },
    methods: {
        onClick() {
            if(this.disabled) return
            this.showSelect = true
        },
        onConfirm(value, index) {
            this.showSelect = false
            if (typeof value === 'string' || typeof value === 'number') {
                // 代表select传值为label
                this[this.paramName] = value
                this.paramCode ? (this[this.paramCode] = value) : ''
                return
            }
            if (!value.label || !value.value) {
                throw Error('options 数据格式有误，必须包含label、value属性 ')
            }
            this[this.paramName] = value.label
            if (this.paramCode) {
                this[this.paramCode] = value.value
            }
            this.$emit('onConfirm', value, index)
        },
        onChange(picker, value, index) {
            this.$emit('onChange', value, index)
        }
    },
    watch: {
        initValue(newVal) {
            if (this.paramCode) {
                // 存在value  则默认初始值为value
                this[this.paramCode] = newVal
                const sIndex = this.options.findIndex(item => item.value === newVal)
                if(sIndex !== -1) {
                    this[this.paramName] = this.options[sIndex].label
                    this.dIndex = sIndex // 设置选中的下标
                }
            } else {
                this[this.paramName] = newVal
                let sIndex ;
                if(typeof this.options[0] === "object") {
                    sIndex = this.options.findIndex(item => item.label === newVal)
                }
                else {
                    sIndex = this.options.findIndex(item => item === newVal)
                }
                if(sIndex !== -1) {
                    this.dIndex = sIndex // 设置选中的下标
                }
                
            }
        }
    },
    mounted() {
        if (this.initValue === '' || this.initValue == undefined) {
            if (this.options.length > 0 &&  this.defaultIndex >= 0) {
                this.paramCode ? this[this.paramCode] = this.options[this.defaultIndex].value : ''
                this.paramName ? this[this.paramName] = this.options[this.defaultIndex].label : ''
            }
        }
    }
}
</script>
<style lang="less" scoped>
.selectPicker {
    position: relative;
    .mod-selectCode {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 0;
        height: 0;
    }
}
</style>
